/**
 * VÍDEO 9 — CTA + PROFILE
 * Follow @guilhermeribeiro.ai
 * 10s | 720×900 | SEM ÁUDIO
 * Copy: BoardCopy (Hormozi + Sugarman)
 */

import React from "react";
import {
  AbsoluteFill,
  useCurrentFrame,
  interpolate,
  Easing,
  Sequence,
  Img,
  staticFile,
} from "remotion";
import {CLAMP} from "../../presets/idv";

const T = {
  light: { bg: "#F7F6F2", headline: "#1A1A1A", body: "#4A4A4A", muted: "#999999" },
  accent: "#E84545",
};

const FONT_SERIF = "'Playfair Display', Georgia, serif";
const FONT_MONO = "'JetBrains Mono', 'Fira Code', monospace";
const FONT_SANS = "'Inter', system-ui, sans-serif";
const FONT_CURSIVE = "'Dancing Script', cursive";

const SZ = { top: 70, sides: 50, bottom: 80 };
const CW = 720 - SZ.sides * 2;

const fadeIn = (frame: number, start: number, end: number) =>
  interpolate(frame, [start, end], [0, 1], { extrapolateRight: CLAMP });
const slideUp = (frame: number, start: number, end: number, dist = 20) =>
  interpolate(frame, [start, end], [dist, 0], { extrapolateRight: CLAMP, easing: Easing.out(Easing.ease) });
const scaleIn = (frame: number, start: number, end: number) =>
  interpolate(frame, [start, end], [0.85, 1], { extrapolateRight: CLAMP, easing: Easing.out(Easing.ease) });

const Headline: React.FC<{children: React.ReactNode; size?: number; color: string; delay?: number}> =
  ({children, size = 44, color, delay = 0}) => {
  const frame = useCurrentFrame();
  return (
    <div style={{
      opacity: fadeIn(frame, delay, delay + 15),
      transform: `translateY(${slideUp(frame, delay, delay + 15)})`,
      fontFamily: FONT_SERIF, fontSize: size, fontWeight: 700, lineHeight: 1.15, color, maxWidth: CW,
    }}>{children}</div>
  );
};

const Body: React.FC<{children: React.ReactNode; color: string; delay?: number}> = ({children, color, delay = 15}) => {
  const frame = useCurrentFrame();
  return (
    <div style={{
      opacity: fadeIn(frame, delay, delay + 15),
      transform: `translateY(${slideUp(frame, delay, delay + 15)})`,
      fontFamily: FONT_SERIF, fontSize: 22, fontWeight: 400, lineHeight: 1.4, color, maxWidth: CW,
    }}>{children}</div>
  );
};

const ProfileCTA: React.FC<{delay?: number}> = ({delay = 0}) => {
  const frame = useCurrentFrame();
  const photoScale = interpolate(frame, [delay, delay + 15], [0.8, 1], {extrapolateRight: CLAMP, easing: Easing.out(Easing.ease)});
  const photoOp = fadeIn(frame, delay, delay + 15);
  return (
    <div style={{display: "flex", flexDirection: "column", alignItems: "center", gap: 16}}>
      <div style={{position: "relative", width: 100, height: 100, opacity: photoOp}}>
        {[3, 2, 1].map((ring) => (
          <div key={ring} style={{
            position: "absolute", inset: (ring - 1) * -20, borderRadius: "50%",
            border: `1px solid rgba(0,0,0,0.06)`, transform: `scale(${photoScale})`,
          }} />
        ))}
        <div style={{
          width: 100, height: 100, borderRadius: "50%", overflow: "hidden",
          border: "2px solid rgba(0,0,0,0.1)", transform: `scale(${photoScale})`,
        }}>
          <Img src={staticFile("assets/profiles/guilhermeribeiro-ai.jpg")} style={{width: "100%", height: "100%", objectFit: "cover"}} />
        </div>
      </div>
      <Headline size={44} color={T.light.headline} delay={delay + 15}>Marketing, Dados & IA</Headline>
      <Body color={T.light.body} delay={delay + 25}><i>Siga para mais dicas.</i></Body>
      <div style={{width: 40, height: 2, background: "#CCC", marginTop: 16, marginBottom: 16, opacity: fadeIn(frame, delay + 30, delay + 40)}} />
      <span style={{opacity: fadeIn(frame, delay + 30, delay + 40), fontFamily: FONT_SANS, fontSize: 15, color: T.light.muted}}>@guilhermeribeiro.ai</span>
    </div>
  );
};

const SeriesLabel: React.FC = () => {
  const frame = useCurrentFrame();
  return (
    <div style={{position: "absolute", top: 30, left: SZ.sides, opacity: fadeIn(frame, 0, 10), fontFamily: FONT_MONO, fontSize: 13, fontWeight: 500, letterSpacing: 2, textTransform: "uppercase", color: T.light.muted}}>SISTEMA DE MARKETING</div>
  );
};

export const Video09CTA: React.FC = () => (
  <AbsoluteFill style={{backgroundColor: T.light.bg}}>
    <Sequence from={0} durationInFrames={300}>
      <AbsoluteFill style={{justifyContent: "center", alignItems: "center", padding: `${SZ.top}px ${SZ.sides}px ${SZ.bottom}px`}}>
        <SeriesLabel />
        <ProfileCTA delay={0} />
      </AbsoluteFill>
    </Sequence>
  </AbsoluteFill>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
